import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Box, Button, Text } from './common';
import { ChevronLeft, ChevronDown } from 'styled-icons/octicons';
import SvgIcon from './SvgIcon';

const ButtonWrapper = styled(Button)`
  display: flex;
`;

function SummaryButton(props) {
  const { expanded, leftIcon, title, subtitle, ...restProps } = props;
  const titleColor = 'primary';
  const buttonVariant = 'secondary';
  const iconVariant = 'primary';

  return (
    <ButtonWrapper variant={buttonVariant} {...restProps}>
      <Box display="flex" justifyContent="center" alignItems="center">
        <SvgIcon width={18} height={18} name={leftIcon} variant={iconVariant} />
      </Box>
      <Box
        mx={4}
        flex={1}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        flexDirection="row"
      >
        <Text fontSize={2} color={titleColor} textTransform="capitalize">
          {title}
        </Text>
        {subtitle && (
          <Text fontSize={2} color={titleColor} textTransform="capitalize">
            {subtitle}
          </Text>
        )}
      </Box>
      {expanded ? <ChevronDown size="20" /> : <ChevronLeft size="20" />}
    </ButtonWrapper>
  );
}

SummaryButton.propTypes = {
  leftIcon: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  expanded: PropTypes.bool
};

SummaryButton.defaultProps = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  rightIcon: []
};

export default SummaryButton;
